var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "t-error-page"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('p', [_vm._v(_vm._s(_vm.friendly) + " ☹")]), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reload
    }
  }, [_vm._v("Try again")]), _vm.message ? _c('div', {
    staticClass: "t-error-detail"
  }, [_c('h2', [_vm._v("Detail")]), _c('pre', [_vm._v(_vm._s(_vm.message))])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }